import type { ComponentProps } from "react";
import { textFieldClasses } from "./text-field-classes";

// Canonical text controls. The label stays at the call site (`.field-label`
// inside a <label className="block">, or aria-label), so the primitive is the
// control alone, like Button. See UI_CONVENTIONS "Text Field".

interface TextFieldOptions {
  mono?: boolean;
}

export function TextInput({
  mono,
  className,
  type = "text",
  ...props
}: ComponentProps<"input"> & TextFieldOptions) {
  return <input type={type} className={textFieldClasses({ mono, className })} {...props} />;
}

export function TextArea({ mono, className, ...props }: ComponentProps<"textarea"> & TextFieldOptions) {
  return <textarea className={textFieldClasses({ mono, multiline: true, className })} {...props} />;
}
